import { useState } from 'react';
import { ImageIcon } from 'lucide-react';

interface MediaThumbProps {
  src: string | null | undefined;
  alt?: string;
  className?: string;
  iconSize?: number;
}

/**
 * Image with a minimalist fallback when the URL is missing or fails to load.
 * The fallback is a muted tile with a small image-glyph — never a blank or
 * grey box.
 */
export function MediaThumb({ src, alt = '', className = '', iconSize = 18 }: MediaThumbProps) {
  const [errored, setErrored] = useState(false);
  const showFallback = !src || errored;

  if (showFallback) {
    return (
      <div
        aria-hidden={alt ? undefined : true}
        className={`bg-muted text-muted-foreground/50 flex items-center justify-center ${className}`}
      >
        <ImageIcon size={iconSize} strokeWidth={1.25} />
      </div>
    );
  }

  return (
    <div className={`bg-muted overflow-hidden ${className}`}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onError={() => setErrored(true)}
        className="w-full h-full object-cover"
      />
    </div>
  );
}
